import { createFileRoute } from '@tanstack/react-router'
import { SetupScreen } from '@/features/setup/routes/setup-screen'

export const Route = createFileRoute('/setup')({ component: SetupScreen })
